module.exports = __webpack_public_path__ + "img/step2.fd846bfc.png";